// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadPrimitive {
  display: flex;
  height: 36px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: var(--color_primary_500);
}
.UploadPrimitive-icon {
  color: var(--color_neutral_0);
  flex-shrink: 0;
}
.UploadPrimitive-content {
  color: var(--color_neutral_0);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/modules/documents/upload-primitive/upload-primitive.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,oCAAA;AACF;AACE;EACE,6BAAA;EACA,cAAA;AACJ;AAEE;EACE,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAAJ","sourcesContent":[".UploadPrimitive {\n  display: flex;\n  height: 36px;\n  padding: 8px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 4px;\n  background: var(--color_primary_500);\n\n  &-icon {\n    color: var(--color_neutral_0);\n    flex-shrink: 0;\n  }\n\n  &-content {\n    color: var(--color_neutral_0);\n    text-align: center;\n    font-size: 14px;\n    font-weight: 400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
